module.exports = __webpack_public_path__ + "img/section2_bg.1999fd98.png";